var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8881 34.9201V37.9201C39.8892 38.1986 39.8322 38.4743 39.7206 38.7294C39.6091 38.9846 39.4454 39.2137 39.2402 39.402C39.035 39.5902 38.7927 39.7336 38.5289 39.8228C38.265 39.912 37.9855 39.9452 37.7081 39.9201C34.631 39.5857 31.6751 38.5342 29.0781 36.8501C26.6619 35.3148 24.6135 33.2663 23.0781 30.8501C21.3881 28.2413 20.3364 25.2711 20.0081 22.1801C19.9831 21.9036 20.016 21.6249 20.1046 21.3617C20.1932 21.0986 20.3357 20.8568 20.5229 20.6517C20.7101 20.4466 20.9379 20.2828 21.1919 20.1706C21.4459 20.0584 21.7205 20.0004 21.9981 20.0001H24.9981C25.4834 19.9953 25.9539 20.1672 26.3219 20.4836C26.6898 20.8001 26.9302 21.2395 26.9981 21.7201C27.1247 22.6802 27.3596 23.6228 27.6981 24.5301C27.8327 24.888 27.8618 25.277 27.782 25.651C27.7023 26.0249 27.517 26.3682 27.2481 26.6401L25.9781 27.9101C27.4017 30.4136 29.4746 32.4865 31.9781 33.9101L33.2481 32.6401C33.52 32.3712 33.8633 32.1859 34.2372 32.1062C34.6112 32.0264 35.0002 32.0556 35.3581 32.1901C36.2654 32.5286 37.2081 32.7635 38.1681 32.8901C38.6539 32.9586 39.0975 33.2033 39.4146 33.5776C39.7318 33.9519 39.9003 34.4297 39.8881 34.9201Z",
    fill: "#F8B326",
    stroke: "#F8B326",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCircle);
export default __webpack_public_path__ + "static/media/callCircle.e1dbb8282cf3299cce2681ad1d75449e.svg";
export { ForwardRef as ReactComponent };